import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

type useApiProps = {
}

export const useApi = () => {
    const navigate = useNavigate()
    const token: string | null = localStorage.getItem("token")
    const apiUrl = useMemo(() => process.env.REACT_APP_API_BASE_URL, [])
    const headerAuth = useMemo(() => {
        return {
            "Authorization": `${token}`,
            "Content-Type": "application/json"
        }
    }, [token])

    const fetchApi = useCallback(async (route="", queryParams="") => {
        const fetchUrl = queryParams == "" ? `${apiUrl}/${route}` : `${apiUrl}/${route}?${queryParams}`
        return fetch(fetchUrl, {
            headers: {
                method: "GET",
                ...headerAuth
            }
        })
            .then(async (res) => {
                if (!res.ok) {
                    const error = await res.json()
                    throw error
                }
                return res.json()
            })
            .catch(async (err) => {
                alert(err.detail)
            })
    }, [apiUrl, headerAuth])

    const getUnpaidLicenses = useCallback(() => fetchApi(""), [fetchApi])
    const getFfttPlayers = useCallback((name="") => fetchApi("download-fftt", `name=${name}`), [fetchApi])

    return {
        getUnpaidLicenses,
        getFfttPlayers
    }
}